import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-carousel/lib/styles.css";
import { ProvideAuth } from "hooks/auth";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "state/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "components/scroll-to-top";
import { createRoot } from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn:
    "https://d5233eb179caa170928a1f82614fa501@o4509369904267265.ingest.us.sentry.io/4509373246406656",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const ToastContainerWithStyles = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={7000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      pauseOnFocusLoss
      pauseOnHover
      toastStyle={{
        background: "#1c2a36",
        color: "white",
        opacity: 1,
        border: `.5px solid var(--secondary-color}`,
      }}
    />
  );
};

if (
  process.env.REACT_APP_USE_LOCAL === "true" &&
  process.env.NODE_ENV !== "production"
) {
  // setupServer(true);
}
if (process.env.NODE_ENV === "development") {
  document.title = "S-WEB-L";
}

if (window.location.hostname.includes("sparket.dev")) {
  document.title = "SPARKET-dev";
}

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <ProvideAuth>
          <Helmet>
            <meta
              property="og:description"
              content="Enter Contests, Make Picks, and Win Big!"
            />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
            />
            <meta
              property="og:image"
              content="https://facebook-share-icon.s3.us-west-2.amazonaws.com/sparket_logo.png"
            />
          </Helmet>
          <ScrollToTop />
          <App />
          <ToastContainerWithStyles />
        </ProvideAuth>
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
